import React from 'react';
import PropTypes from 'prop-types';
import { formatToCurrency } from '../../../_modules/currency/format_to_currency';
import { toDangerousReactHtml } from '../../helper/to_dangerous_react_html';
import Translation from '../translation/translation';

export function FormattedPrice({
    price,
    currencyIsoCode,
    className,
    loading,
    inCents,
    showEachPriceLabel,
    overrides,
    isTotalPrice,
}) {
    if (loading || isNaN(price)) {
        return (
            <span className={className}>
                <span className="price price--loading">
                    <span className="price__dots">...</span>
                </span>
            </span>
        );
    }

    if (price < 0) {
        if (isTotalPrice) {
            return <>$0</>
        }
        return <></>;
    }

    if (price === 0 && !isTotalPrice) {
        return (
            <span className={className}>
                <span className="price price--free">free</span>
            </span>
        );
    }

    const formattedPrice = formatToCurrency(price, currencyIsoCode, false, inCents, overrides);
    const preparedDangerousHtml = toDangerousReactHtml(formattedPrice);

    return (
        <span className={className}>
            {
                showEachPriceLabel &&
                <Translation translationKey="catalog-each-unit" className="price--each" />
            }
            <span
                className="price"
                dangerouslySetInnerHTML={preparedDangerousHtml}
            />
        </span>
    );
}

FormattedPrice.propTypes = {
    price: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    className: PropTypes.string,
    loading: PropTypes.bool,
    inCents: PropTypes.bool,
    showEachPriceLabel: PropTypes.bool,
    overrides: PropTypes.object,
};

FormattedPrice.defaultProps = {
    className: '',
    loading: false,
    inCents: false,
    showEachPriceLabel: false,
    overrides: {},
};
